export function Config() {
    return {
        website: {
            scrollToTopOnReload: false,
            navbar: {
                autoHideNavbarOnScroll: false,
                bright: false,
                hidden: false,
                autopilot: false,
            }
        }
    }
}

